import { render, staticRenderFns } from "./MarketplaceSettingsModule.vue?vue&type=template&id=ca352354&scoped=true"
import script from "./MarketplaceSettingsModule.vue?vue&type=script&lang=js"
export * from "./MarketplaceSettingsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca352354",
  null
  
)

export default component.exports